//@ts-nocheck
import React, { FC } from "react";
import { Row, FormCheck, FormGroup } from "react-bootstrap";
import { useField, useFormikContext } from "formik";

interface IProps {
    required?: boolean;
    name?: string;
    text?: string;
    statusFormik?: boolean;
}

const CheckBox: FC<IProps> = ({
    required = false,
    name = "consent",
    text = 'Я даю согласие на получение рассылки <a href="/consentadvertising" target="_blank">рекламно-информационных материалов</a>',
    statusFormik = true,
}) => {
    // Используем useField для управления состоянием поля, если statusFormik === true
    const [field, meta] = statusFormik ? useField({ name, type: "checkbox" }) : [{}, {}];
    // Получаем setFieldValue из Formik-контекста, если statusFormik === true
    const { setFieldValue } = statusFormik ? useFormikContext() : { setFieldValue: () => { } };

    // Обработчик изменения чекбокса
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (statusFormik) {
            setFieldValue(name, e.target.checked);
        }
    };

    return (
        <FormGroup as="div" className="mb-3">
            <FormCheck as="div">
                <FormCheck.Input
                    {...(statusFormik ? field : {})}
                    id={name}
                    name={name}
                    required={required}
                    type="checkbox"
                    onChange={statusFormik ? handleChange : undefined}
                    isInvalid={statusFormik && !!meta.touched && !!meta.error}
                />
                <FormCheck.Label
                    htmlFor={name}
                    className="text-dark fw-normal text-start"
                    dangerouslySetInnerHTML={{ __html: text }}
                />
                {statusFormik && meta.touched && meta.error ? (
                    <div className="invalid-feedback d-block">{meta.error}</div>
                ) : null}
            </FormCheck>
        </FormGroup>
    );
};

export default CheckBox;